module.exports = __webpack_public_path__ + "img/9791188502172.dc09c0cd.jpg";